module.exports = __webpack_public_path__ + "img/404.bd4d699f.png";